var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField } from '@material-ui/core';
var Input = function (props) {
    var name = props.name, label = props.label, _a = props.size, size = _a === void 0 ? 'medium' : _a, value = props.value, _b = props.error, error = _b === void 0 ? null : _b, onChange = props.onChange, other = __rest(props, ["name", "label", "size", "value", "error", "onChange"]);
    return (React.createElement(TextField, __assign({ variant: "outlined", size: size, label: label, name: name, value: value, onChange: onChange }, other, (error && { error: true, helperText: error }))));
};
export default Input;
//# sourceMappingURL=Input.js.map